<template>
    <nuxt-link :to="`/articles/${article.slug}`" class="article_card_row">
        <div class="article_card flex" :class="{ active: article.isPinned }">
            <div v-if="!thumbnailAtBottom" class="image_thumbnail">
                <div
                    v-full-background-image-path:media="article.featuredImage"
                    class="image bg_image cover"
                />
            </div>
            <div class="article_content">
                <div class="article_title">
                    {{ article.name }}
                </div>
                <div class="content">
                    <p>{{ content }}</p>
                </div>
                <div class="article_details_info flex">
                    <div class="article_info">
                        <span v-if="article.author" dir="rtl" class="author">
                            {{ article.author.fullName }}
                        </span>
                        <span dir="rtl" class="date">
                            {{ article.updatedAt | formatDate }}
                        </span>
                    </div>
                </div>
                <div class="tags_list flex">
                    <div v-for="tag in article.tags" :key="tag.id" class="tag">
                        <span class="active">{{ tag.name }}</span>
                    </div>
                    <div v-if="article.category" class="tag">
                        <span>
                            {{ article.category.name }}
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="thumbnailAtBottom" class="image_thumbnail">
                <div
                    v-full-background-image-path:media="article.featuredImage"
                    class="image bg_image cover"
                />
            </div>
        </div>
    </nuxt-link>
</template>

<script>
export default {
    props: {
        article: {
            type: Object,
            required: true
        },
        thumbnailAtBottom: {
            type: Boolean,
            required: false,
            default: false
        }
    },

    computed: {
        content() {
            const regex = /(<([^>]+)>|&nbsp;)/gi;
            const text = this.article.content.find(item => item.key === 'text');

            return text?.value?.replace(regex, '') || '';
        }
    }
};
</script>
